import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

import Link from '../../utils/link'
import { Plus, Email, Phone, LinkedInLetters } from '../icons'

const TeamCard = ({ title, acf, regions, divisions, sites }) => {
  const [active, setActive] = React.useState(false)

  const show = !!sites?.nodes?.find(site => site.slug === process.env.GATSBY_WP_CATEGORY_SITE_SLUG)
  if (!show) return null

  return (
    <Fade bottom distance='40px'>
      <div className='team-card'>
        {acf.image?.localFile && (
          <GatsbyImage loading='lazy' image={getImage(acf.image.localFile)} alt={title} />
        )}
        <div className='team-card__inner'>
          <div className='team-card__initial'>
            <h4 onClick={() => setActive(!active)}>
              <span>{title}</span>
              <Plus active={active} />
            </h4>
            {acf.position && <h5>{acf.position}</h5>}
            {acf.phone && <p><Link to={`tel:${acf.phone}`}>{acf.phone}</Link></p>}
            {acf.email && <p><Link to={`mailto:${acf.email}`}>{acf.email}</Link></p>}
          </div>
          {active && (
            <div className='team-card__extended'>
              {acf.content && <div className='team-card__content'>{parse(acf.content)}</div>}
              {regions?.nodes?.length > 0 && (
                <div className='team-card__tags'>
                  <h6>States</h6>
                  <ul>
                    {regions.nodes.map((el, i) => (<li key={i}>{el.name}</li>))}
                  </ul>
                </div>
              )}
              {divisions?.nodes?.length > 0 && (
                <div className='team-card__tags'>
                  <h6>Divisions</h6>
                  <ul>
                    {divisions.nodes.map((el, i) => (<li key={i}>{el.name}</li>))}
                  </ul>
                </div>
              )}
              <div className='team-card__icons'>
                {acf.phone && <Link to={`tel:${acf.phone}`}><Phone /></Link>}
                {acf.email && <Link to={`mailto:${acf.email}`}><Email /></Link>}
                {acf.linkedin && <Link to={acf.linkedin}><LinkedInLetters /></Link>}
              </div>
            </div>
          )}
        </div>
      </div>
    </Fade>
  )
}

export default TeamCard